import { reportDegradation } from '@payments-checkout/shared/observability';
import { useEffect, useState } from 'react';
import { usePageSharedData } from '../../../hooks/usePageSharedData';
import { canMakeApplePayments, waitForApplePaySdk } from '../../helpers/applePaySdk';

type ApplePayAvailabilityStatus = 'pending' | 'available' | 'unavailable';

export const useApplePayAvailability = () => {
  const { paymentLinkIdData } = usePageSharedData();
  const enabledByMerchant =
    !!paymentLinkIdData?.data?.payment_settings.apple_pay_enabled;
  const [status, setStatus] = useState<ApplePayAvailabilityStatus>('pending');

  useEffect(() => {
    if (!enabledByMerchant) {
      setStatus('unavailable');
      return;
    }

    let cancelled = false;

    (async () => {
      const loaded = await waitForApplePaySdk();
      if (cancelled) return;

      if (!loaded) {
        reportDegradation(
          'digital_wallet_unavailable',
          new Error('Apple Pay JS SDK não carregou'),
          { wallet: 'apple_pay', reason: 'sdk_not_loaded' }
        );
        setStatus('unavailable');
        return;
      }

      const canPay = canMakeApplePayments();
      if (!canPay) {
        reportDegradation('digital_wallet_unavailable', undefined, {
          wallet: 'apple_pay',
          reason: 'cannot_make_payments',
        });
      }
      setStatus(canPay ? 'available' : 'unavailable');
    })();

    return () => {
      cancelled = true;
    };
  }, [enabledByMerchant]);

  return {
    isApplePayAvailable: status === 'available',
    isApplePayLoading: status === 'pending',
  };
};
